import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TokenService } from 'src/app/core/token/token.service';
declare let moment: any;

@Component({
  selector: 'datepicker-padrao',
  templateUrl: './datepicker-padrao.component.html',
  styleUrls: ['./datepicker-padrao.component.scss']
})
export class DatepickerPadraoComponent implements OnInit, AfterViewInit {
  selectedValue;
  private modelValue;
  private ultimoValorEmitido;
  @Input() set model(value) {
    this.modelValue = value;
    this.setDatepickerTime(value)
  };
  @Input() dataMinima;
  @Input() dataMaxima;
  @Input() required;
  @Input() disabled;
  @Input() disabledHours;
  @Input() is_range;
  @Input() inline;
  @Output() dateChange = new EventEmitter();
  @ViewChild('dp') dp: ElementRef;

  locale = 'pt-br';

  @Input() idNumber
  @Input() readonly: boolean;
  horas;
  minutos;
  uniqueID;

  constructor(
    private elem: ElementRef,
    private _localeService: BsLocaleService,
    private tokenService: TokenService
  ) { }

  ngOnInit(): void {
    this.uniqueID = 'dp' + Math.random().toString(36).substring(2);
    this._localeService.use(this.locale);
    this.setHourInSelectedValue(this.selectedValue);
  }

  ngAfterViewInit(): void {
    if (this.modelValue) {
      setTimeout(() => {
        this.setDatepickerTime(this.modelValue);
      }, 0);
    }
  }

  formatValorData(value) {
    return value && value.toString().includes(':') ? value : `${value} 00:00:00`
  }

  setHourInSelectedValue(value: Date): void {
    if (this.dataMinima && this.dataMinima instanceof Date && !isNaN(this.dataMinima as any) && !this.disabledHours && !this.disabled) {
      this.dataMinima.setHours(value.getHours());
      this.dataMinima.setMinutes(value.getMinutes());
      this.dataMinima.setSeconds(value.getSeconds());
      //this.dateChange.emit(moment(this.dataMinima).format('YYYY-MM-DD HH:mm:ss'));      
      this.compareDate(this.dataMinima, value);
    }
  }

  compareDate(dataMinima, value) {
    if (dataMinima >= value) {
      this.dateChange.emit(moment(this.dataMinima).format('YYYY-MM-DD HH:mm:ss'));
    } else {
      this.dateChange.emit(moment(value).format('YYYY-MM-DD HH:mm:ss'));
    }
  }

  setDatepickerTime(value) {
    if (this.is_range || Array.isArray(value)) {
      this.selectedValue = value && value[0] && value[1]
        ? [new Date(value[0]), new Date(value[1])]
        : null;
    } else {
      this.selectedValue = value ? new Date(this.formatValorData(value)) : '';
    }
  }

  // com o campo vazio, o calendário do ngx-bootstrap devolve o dia com a hora do carregamento da página
  emitValueComHoraAtual(value): void {
    if (value instanceof Date && !this.modelValue && !this.ultimoValorEmitido) {
      const agora = new Date();
      value = new Date(value);
      value.setHours(agora.getHours(), agora.getMinutes(), agora.getSeconds());
      this.selectedValue = value;
    }
    this.emitValue(value);
  }

  emitValue(value): void {
    this.ultimoValorEmitido = value;
    //if(value) {
    this.dateChange.emit(value ? value : null);
    //}
  }

  verificaRequerido(): boolean {
    if (this.required === true) {
      if (this.selectedValue) {
        if (this.selectedValue !== '' || this.selectedValue !== null) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  setHours(hour, elem): void {
    this.horas = hour;
    var dropHoras = document.getElementsByClassName('drop-horas');
    for (var i = 0; i < dropHoras.length; i++) {
      dropHoras[i].classList.remove('hora-selecionada');
    }
    elem.classList.add('hora-selecionada');

    if (this.selectedValue) {
      var oldVal = this.dp['_elementRef'].nativeElement.value.split(' ');
      let oldMin = oldVal[1].split(':')
      this.dp['_elementRef'].nativeElement.value = oldVal[0] + " " + hour + ":" + ((this.minutos) ? this.minutos : oldMin[1]);
      this.selectedValue.setHours(hour);
      this.emitValue(this.selectedValue);
    } else {
      this.selectedValue = new Date();
      this.selectedValue.setHours(hour);
      this.selectedValue.setMinutes(0);
      this.emitValue(this.selectedValue);
    }
  }

  setMinutes(min, elem): void {
    this.minutos = min;
    var dropHoras = document.getElementsByClassName('drop-minutos');
    for (var i = 0; i < dropHoras.length; i++) {
      dropHoras[i].classList.remove('hora-selecionada');
    }
    elem.classList.add('hora-selecionada');

    if (this.selectedValue !== undefined && this.selectedValue !== null) {
      var oldVal = this.dp['_elementRef'].nativeElement.value.split(' ');
      let oldHour = oldVal[1].split(':')
      this.dp['_elementRef'].nativeElement.value = oldVal[0] + " " + ((this.horas) ? this.horas : oldHour[0]) + ":" + min;
      this.selectedValue.setMinutes(min);
      this.emitValue(this.selectedValue);
    } else {
      this.selectedValue = new Date();
      this.selectedValue.setHours(0);
      this.selectedValue.setMinutes(min);
      this.emitValue(this.selectedValue);
    }
  }
}
